import React from 'react';
import i18n from 'i18n-react';

import { FastFacts, ContentHeader, BackButton } from 'C4';

const FastFactsView = () => (
  <div className="contentContainer">
    <ContentHeader
      header={i18n.translate('nav.promote')}
      subtitle={i18n.translate('pageDescriptions.promote')}
      social
    />
    <FastFacts />
    <style>{'\
    .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } '}
    </style>
  </div>
);

export default FastFactsView;
